import type { ReactNode } from 'react'
import { Stack, Typography } from '@mui/material'

export type TStatusPlaceholderProps = {
  type: 'loading' | 'error' | 'empty'
  text: string
  icon: ReactNode
  height?: number | string
  children?: ReactNode
}

export const StatusPlaceholder = ({
  type,
  text,
  icon,
  height = 200,
  children,
}: TStatusPlaceholderProps) => (
  <Stack
    alignItems="center"
    justifyContent="center"
    sx={{ height }}
    spacing={type === 'loading' ? 2 : 1}
  >
    {icon}
    <Typography
      color={type === 'error' ? 'error' : 'text.secondary'}
      fontWeight={type === 'error' ? 500 : undefined}
    >
      {text}
    </Typography>
    {children}
  </Stack>
)
